/*
 * @Author       : zxlin
 * @Date         : 2023-08-09 13:36:40
 * @LastEditors  : zxlin
 * @LastEditTime : 2023-10-10 17:02:34
 * @FilePath     : \h5-vue3-template\src\api\home.js
 * @Description  : 首页相关api
 */
import axios from '@/utils/axios'
const request = axios()

/**
 * demo
 * @returns
 */
// export function demo() {
//   return request({
//     method: 'get',
//     url: '/api/demo',
//   })
// }
export function apiGet(url_get, param) {
  return request({
    method: 'get',
    url: url_get,
    params: param
  })
}
export function adminLogin(param) {
  return request({
    method: 'get',
    url: '/adminLogin',
    params: param
  })
}
//  获取所有二级管理员
export function getSecondAdmin(param) {
  return request({
    method: 'get',
    url: '/getSecondAdmin',
    params: param
  })

}
//  创建二级管理员
export function createAdmin(param) {
  return request({
    method: 'get',
    url: '/createSecondAdmin',
    params: param
  })
}
// 修改二级管理员
export function modifySecondAdmin(param) {
  return request({
    method: 'get',
    url: '/modifySecondAdmin',
    params: param
  })
}
// 删除二级管理员
export function delAdmin(param) {
  return request({
    method: 'get',
    url: '/delSecondAdmin',
    params: param
  })
}
// 单条上传
export function update_strip(param) {
  return request({
    method: 'get',
    url: '/update_strip_Auth',
    params: param
  })
}
// excel上传

export function update_excel(param) {
  return request({
    method: 'get',
    url: '/excelUpdata',
    params: param
  })
}

// 获取数据总数量

export function getDataCount(param) {
  return request({
    method: 'get',
    url: '/getdataCount',
    params: param
  })
}
// 获取所有授权人
export function getAuthAll(param) {
  return request({
    method: 'get',
    url: '/authAll',
    params: param
  })
}

// 上传图片
export function put_file(data) {
  return request({
    url: '/up_picture',
    method: 'post',
    data,
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 0
  })
}

// 医师查询
export function getAllDoctor(param) {
  return request({
    url: '/get_all_doctor',
    method: 'get',
    params: param
  })
}
// 创建医师
export function createDoctor(param) {
  return request({
    url: '/create_doctor',
    method: 'get',
    params: param
  })
}
// 删除医师
export function delDocter(param) {
  return request({
    url: '/del_docter',
    method: 'get',
    params: param
  })
}
// 创建医师视频信息
export function addVideo(param) {
  return request({
    url: '/add_video',
    method: 'get',
    params: param
  })
}
// 创建医师视频信息
export function getVideo(param) {
  return request({
    url: '/get_video',
    method: 'get',
    params: param
  })
}
// 创建医师视频信息
export function delVideo(param) {
  return request({
    url: '/del_video',
    method: 'get',
    params: param
  })
}
//修改视频状态
export function modifyVideo(param) {
  return request({
    url: '/modify_video',
    method: 'get',
    params: param
  })
}
//生成优惠码
export function createCode(param) {
  return request({
    url: '/create_code',
    method: 'get',
    params: param
  })
}
//获取优惠订单分页数据
export function getDisOrder(param) {
  return request({
    url: '/get_dis_order',
    method: 'get',
    params: param
  })
}

// 测试创建普通订单
export function create_order(data){
  return request({
    method: 'post',
    url: '/create_order',
    data
  })
}
// 获取订单
export function get_user_order(param){
  return request({
    method: 'get',
    url: '/get_user_order',
    params: param
  })
}


// 批量创建业务员
export function create_user(param){
  return request({
    method: 'get',
    url: '/create_y_user',
    params: param,
    headers: { 'Content-Type': 'application/json-patch+json' },
  })
}
// 分类获取用户
export function getuerType(param){
  return request({
    method: 'get',
    url: '/getuer_type',
    params: param
  })
}

// 删除
export function delUser(param){
  return request({
    method: 'get',
    url: '/del_user',
    params: param
  })
}
// 去除重复
export function delRepeat(param){
  return request({
    method: 'get',
    url: '/del_repeat',
    params: param
  })
}
// 获取优惠码价格
export function getDisPrice(param){
  return request({
    method: 'get',
    url: '/get_dis_price',
    params: param
  })
}
// 修改优惠码价格
export function upDisPrice(param){
  return request({
    method: 'get',
    url: '/up_dis_price',
    params: param
  })
}